<script>
import { mapActions } from 'vuex';

const UFS = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT',
  'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];

const STATUS = [
  { value: 'ativo', label: 'Ativo' },
  { value: 'inativo', label: 'Inativo' },
  { value: 'bloqueado', label: 'Bloqueado' },
];

export default {
  name: 'PainelPerfil',
  props: {
    contato: { type: Object, required: true },
  },
  data() {
    return {
      ufs: UFS,
      statusOpts: STATUS,
      form: this._formDe(this.contato),
      salvando: false,
      erro: null,
      sucesso: null,
    };
  },
  watch: {
    contato: {
      handler(novo) { this.form = this._formDe(novo); this.erro = null; this.sucesso = null; },
      deep: true,
    },
  },
  methods: {
    _formDe(c) {
      return {
        nome: c?.nome || '',
        sobrenome: c?.sobrenome || '',
        documento: c?.documento || '',
        cep: c?.cep || '',
        estado: c?.estado || '',
        cidade: c?.cidade || '',
        bairro: c?.bairro || '',
        logradouro: c?.logradouro || '',
        numero: c?.numero || '',
        complemento: c?.complemento || '',
        status_contato: c?.status_contato || 'ativo',
      };
    },
    ...mapActions('atendimento', ['atualizarContato']),
    async salvar() {
      this.salvando = true;
      this.erro = null;
      this.sucesso = null;
      try {
        // Vai via store: faz PUT /contato/:id e propaga via mutation
        // UPDATE_CONTATO — header do drawer e InboxList atualizam sozinhos.
        await this.atualizarContato({ id: this.contato.id, dados: this.form });
        this.sucesso = 'Perfil atualizado.';
        setTimeout(() => { this.sucesso = null; }, 2500);
      } catch (error) {
        this.erro = (error.response && error.response.data && error.response.data.error) || error.message;
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<template>
  <div class="painel-perfil">
    <h6 class="mb-3"><i class="ri-user-line me-1"></i>Dados do contato</h6>

    <div v-if="erro" class="alert alert-danger py-2 small">{{ erro }}</div>
    <div v-if="sucesso" class="alert alert-success py-2 small">{{ sucesso }}</div>

    <!-- Form sempre editável -->
    <div class="row g-2">
      <div class="col-12">
        <label class="form-label small">Nome *</label>
        <input v-model="form.nome" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-12">
        <label class="form-label small">Sobrenome</label>
        <input v-model="form.sobrenome" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-12">
        <label class="form-label small">Documento (CPF/RG)</label>
        <input v-model="form.documento" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-7">
        <label class="form-label small">Cidade</label>
        <input v-model="form.cidade" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-5">
        <label class="form-label small">UF</label>
        <select v-model="form.estado" class="form-select form-select-sm">
          <option value="">—</option>
          <option v-for="uf in ufs" :key="uf" :value="uf">{{ uf }}</option>
        </select>
      </div>
      <div class="col-7">
        <label class="form-label small">Bairro</label>
        <input v-model="form.bairro" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-5">
        <label class="form-label small">CEP</label>
        <input v-model="form.cep" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-9">
        <label class="form-label small">Logradouro</label>
        <input v-model="form.logradouro" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-3">
        <label class="form-label small">Nº</label>
        <input v-model="form.numero" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-12">
        <label class="form-label small">Complemento</label>
        <input v-model="form.complemento" type="text" class="form-control form-control-sm" />
      </div>
      <div class="col-12">
        <label class="form-label small">Status</label>
        <select v-model="form.status_contato" class="form-select form-select-sm">
          <option v-for="s in statusOpts" :key="s.value" :value="s.value">{{ s.label }}</option>
        </select>
      </div>
    </div>

    <button type="button" class="btn btn-primary btn-sm w-100 mt-3" :disabled="salvando" @click="salvar">
      <i v-if="salvando" class="ri-loader-4-line spin me-1"></i>
      <i v-else class="ri-save-line me-1"></i>{{ salvando ? 'Salvando...' : 'Salvar perfil' }}
    </button>
  </div>
</template>

<style scoped>
.spin { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
</style>
